import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '../../shared/shared.module';
import { SipCardAssuredComponent } from './sip-card-assured.component';
import { OfferNoteModule } from '../offer-note/offer-note.module';
@NgModule({
  declarations: [SipCardAssuredComponent],
  exports: [SipCardAssuredComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    SharedModule,
    OfferNoteModule
  ]
})
export class SipCardAssuredModule { }
